import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center space-x-3 rtl:space-x-reverse">
      <img
        src="/dabv-logo.png"
        alt="DABV Logo"
        className="h-12 object-contain" // 80px x 80px, adjust as you like
        loading="lazy"
      />
    </div>
  );
};

export default Logo;
